<template>
  <div>
    <div v-if="isLargeScreen" class="header-logo-wrapper p-0">
      <div class="toggle-sidebar" @click="toggleMenu">
        <img v-if="!showMenu" src="@/assets/images/driver/list.png" style="height: 20px; width: 20px;" />
        <img v-else src="@/assets/images/driver/close.png" style="height: 20px; width: 20px;" />
      </div>
    </div>

    <transition name="slide-down">
      <div v-if="showMenu" class="full-screen-menu">
        <ul>
          <li :class="{ active: isActive('/') }" @click="navigate('/')">
            <img src="@/assets/images/driver/overview.png" class="menu-icon" /> Overview
          </li>
          <li @click="toggleSubMenu('payments')">
            <img src="@/assets/images/driver/payments.png" class="menu-icon" /> Payments
            <ul v-if="subMenu === 'payments'" class="submenu">
              <li :class="{ active: isActive('/transaction') }" @click="navigate('/transaction')">Transactions</li>
              <li :class="{ active: isActive('/settlements') }" @click="navigate('/settlements')">Settlements</li>
            </ul>
          </li>
          <li :class="{ active: isActive('/reports') }" @click="navigate('/reports')">
            <img src="@/assets/images/driver/reports.png" class="menu-icon" /> Reports
          </li>
          <!-- withdraw_enabled 條件判斷：只有 withdraw_enabled 為 true 時顯示 -->
          <li v-if="currentUser && currentUser.withdraw_enabled === true" :class="{ active: isActive('/withdraw-funds') }" @click="navigate('/withdraw-funds')">
            <img src="@/assets/images/driver/withdraw.png" class="menu-icon" /> Withdraw Funds
            <!-- <img src="@/assets/images/driver/new.png" class="new-icon" />  -->
          </li>
          <li :class="{ active: isActive('/profile') }" @click="navigate('/profile')">
            <img src="@/assets/images/driver/profile.png" class="menu-icon" /> Profile
          </li>
          <li
            v-if="currentUser && currentUser.pre_card_enabled === true"
            :class="{ active: isActive('/card-payment') }"
            @click="navigate('/card-payment')"
          >
            <img src="@/assets/images/driver/card.png" class="menu-icon" /> Cards
            <img src="@/assets/images/driver/new.png" class="new-icon" /> 
          </li> 
          <hr class="menu-divider">
          <li :class="{ active: isActive('/help') }" @click="navigate('/help')">
            <img src="@/assets/images/driver/help.png" class="menu-icon" /> Help
          </li>
          <li :class="{ active: isActive('/logout') }" @click="logout()">
            <img src="@/assets/images/driver/logout.png" class="menu-icon" /> Logout
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const isLargeScreen = ref(false);
const showMenu = ref(false);
const subMenu = ref(null); // 控制展開的母選單
const router = useRouter();
const currentRoute = useRoute(); // 用於監聽當前路由

// 取得前台使用者資料
const currentUser = ref(null);

// 檢查螢幕大小
function checkScreenSize() {
  isLargeScreen.value = window.innerWidth <= 992;
}

// 切換側邊欄
function toggleMenu() {
  showMenu.value = !showMenu.value;
}

// 切換子選單
function toggleSubMenu(menu) {
  subMenu.value = subMenu.value === menu ? null : menu;
}

// 導航至新的路由
function navigate(to) {
  router.push(to);
  toggleMenu();
}

// 判斷當前路由是否與傳入的路徑匹配
function isActive(routePath) {
  return currentRoute.path === routePath;
}

// 判斷是否需要展開 Payments 子選單
function isSubMenuActive() {
  return currentRoute.path.startsWith('/transaction') || currentRoute.path.startsWith('/settlements');
}

// 登出邏輯
function logout() {
  const currentPath = currentRoute.path;
  const driverToken = localStorage.getItem('driverToken');
  const adminToken = localStorage.getItem('adminToken');

  if (currentPath.startsWith('/admin')) {
    // 後台登出
    if (adminToken) {
      localStorage.removeItem('Admin');
      localStorage.removeItem('adminToken');
      router.replace('/admin/login'); // 導向後台登入頁面
    }
  } else {
    // 前台登出
    if (driverToken) {
      localStorage.removeItem('Driver');
      localStorage.removeItem('driverToken');
      router.replace('/auth/login'); // 導向前台登入頁面
    }
  }
}

onMounted(() => {
  checkScreenSize();
  window.addEventListener('resize', checkScreenSize);

  // 取得前台使用者資料 (Driver)
  currentUser.value = JSON.parse(localStorage.getItem('Driver'));

  // 如果當前路由是 Payments 的子路徑，則自動展開
  if (isSubMenuActive()) {
    subMenu.value = 'payments';
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', checkScreenSize);
});
</script>

<style scoped>
.full-screen-menu {
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  height: calc(100dvh - 80px);
  max-height: calc(100dvh - 80px);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  z-index: 999; /* 確保下拉選單顯示在卡片上方 */
  border-radius: 15px 15px 0px 0px;
}

.full-screen-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: fit-content;
}

.full-screen-menu li {
  width: 100%;
  padding: 20px;
  cursor: pointer;
  align-items: center;
  font-family: Euclid Square;
  font-size: 18px;
  font-weight: 500;
  line-height: 22.82px;
}

.full-screen-menu li .submenu {
  flex-direction: column;
  margin-top: 20px;
  padding-left: 40px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.submenu li {
  font-family: Euclid Square;
  font-size: 16px;
  font-weight: 400;
  line-height: 20.29px;
  text-align: left;
}

.menu-icon {
  height: 30px;
  width: 30px;
  margin-right: 30px;
}

.new-icon {
  width: 61px;
  height: 32px;
  margin-left: 30px;
}

.menu-divider {
  width: 100%;
  border: none;
  height: 1px;
  margin-top: 40px;
  border-bottom: 1px solid black;
}

/* Vue 3 transition：關閉時透明仍會擋住點擊，需關掉 pointer-events */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-100%);
  pointer-events: none;
}

.slide-down-enter-to,
.slide-down-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* Active 狀態樣式 */
.active {
  background-color: #ccf4e0; /* 綠色背景 */
  color: black;
  border-radius: 10px;
}
</style>
